export default __webpack_public_path__ + "static/badge_hummingbird-8a904df9084b0282fde5c6da6854c6a1.png";